const u = up.util;
up.EventListener = class EventListener extends up.Record {
    keys() {
        return [
            'element',
            'eventType',
            'selector',
            'callback',
            'guard',
            'baseLayer',
            'passive',
            'once',
            'capture',
            'beforeBoot',
        ];
    }
    constructor(attributes) {
        super(attributes);
        this._key = this.constructor._buildKey(attributes);
        this.isDefault = up.framework.evaling;
        this.beforeBoot ??= (this.eventType.indexOf('up:framework:') === 0);
        this.nativeCallback = this.nativeCallback.bind(this);
    }
    bind() {
        const map = (this.element.upEventListeners ||= {});
        if (map[this._key]) {
            up.fail('up.on(): The %o callback %o cannot be registered more than once', this.eventType, this.callback);
        }
        map[this._key] = this;
        this.element.addEventListener(...this._addListenerArg());
    }
    _addListenerArg() {
        let options = u.compactObject(u.pick(this, ['once', 'passive', 'capture']));
        return [this.eventType, this.nativeCallback, options];
    }
    unbind() {
        let map = this.element.upEventListeners;
        if (map) {
            delete map[this._key];
        }
        this.element.removeEventListener(...this._addListenerArg());
    }
    nativeCallback(event) {
        if (up.framework.beforeBoot && !this.beforeBoot) {
            return;
        }
        let element = event.target;
        if (this.selector) {
            let selector = u.evalOption(this.selector);
            element = element.closest(selector);
        }
        if (this.guard && !this.guard(event)) {
            return;
        }
        if (element) {
            const args = [event, element];
            const expectedArgCount = this.callback.length;
            if (expectedArgCount !== 1 && expectedArgCount !== 2) {
                const data = up.script.data(element);
                args.push(data);
            }
            if (this.eventType === 'click' && element.disabled) {
                return;
            }
            const applyCallback = this.callback.bind(element, ...args);
            if (this.baseLayer) {
                this.baseLayer.asCurrent(applyCallback);
            }
            else {
                applyCallback();
            }
        }
    }
    static fromElement(attributes) {
        let map = attributes.element.upEventListeners;
        if (map) {
            const key = this._buildKey(attributes);
            return map[key];
        }
    }
    static _buildKey(attributes) {
        attributes.callback.upUid ||= u.uid();
        return [
            attributes.eventType,
            attributes.selector,
            attributes.callback.upUid
        ].join('|');
    }
    static allNonDefault(element) {
        let map = element.upEventListeners;
        if (map) {
            const listeners = Object.values(map);
            return u.reject(listeners, 'isDefault');
        }
        else {
            return [];
        }
    }
};
